import { Injectable, signal } from '@angular/core';

/** The span an Atlas window covers, as instants (`from` inclusive, `to` the window's end). */
export interface KpSelectionRange {
  readonly from: Date;
  readonly to: Date;
}

/**
 * Provided by a host whose result lists answer an Atlas time window (the Atlas panel's Sources view: "N sources in the window").
 * The sections and the type counts read it, when it is provided, to narrow their requests to that span. The Knowledge Panel does
 * not provide it, so its lists and counts are unchanged.
 */
@Injectable()
export class KpSelectionWindow {
  public readonly range = signal<KpSelectionRange | null>(null);
}
